import * as React from 'react'
const styles = require('./styles.scss')

export const ContextTitle = ({ children }) => <h3 className={styles.contextTitle}>{children}</h3>
